import { useEditDashboardDraft } from '@/features/Dashboard/context/EditDashboardDraft';
import { useDashboard } from '@/hooks/api/dashboard';

export const useCurrentDashboardConfig = () => {
  const { initialDashboardName } = useEditDashboardDraft();
  const { data: allDashboardsConfig } = useDashboard();
  return allDashboardsConfig?.[initialDashboardName];
};
